/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%}[_nghost-%COMP%]   .ui-g[_ngcontent-%COMP%]{height:100%;overflow:auto}"];
export { styles as styles };
